import React from "react";

interface BankingTransactionItemProps {
  icon?: React.ReactNode;
  title: string;
  subtitle: string;
  amount: string;
  currency?: string;
  positive?: boolean;
}

export default function BankingTransactionItem({
  icon,
  title,
  subtitle,
  amount,
  currency = "USD",
  positive = false,
}: Readonly<BankingTransactionItemProps>) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-gray-700">
      {/* Left Side */}
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-full bg-sidebar-active text-xs font-semibold uppercase text-white">
          {icon}
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-white font-medium">{title}</span>
          <span className="text-xs text-label-dark">{subtitle}</span>
        </div>
      </div>

      {/* Right Side */}
      <div
        className={`text-sm font-semibold ${
          positive ? "text-emerald-500" : "text-red-500"
        }`}>
        {amount} <span className="text-xs text-label-dark">{currency}</span>
      </div>
    </div>
  );
}
